'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _dateConstants = require('../../dateConstants');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatIn(value) {
  if ((0, _lodash.isEmpty)(value)) {
    return [];
  }
  var startDate = value.startDate,
      endDate = value.endDate;

  var start = startDate ? (0, _moment2.default)(startDate) : null;
  var end = endDate ? (0, _moment2.default)(endDate) : null;
  return [start, end];
}

function formatOut(value) {
  if ((0, _lodash.isEmpty)(value)) {
    return {
      startDate: null,
      endDate: null
    };
  }
  var data = {
    startDate: value[0] && value[0].valueOf(),
    endDate: value[1] && value[1].valueOf()
  };
  return data;
}

function defaultValueFormatter(value, $state) {
  var _getProps = (0, _utils.getProps)($state),
      dateType = _getProps.dateType,
      format = _getProps.format,
      readonly = _getProps.readonly;

  var realFormat = _dateConstants.TRANSFORM_FORMAT[format || dateType] || 'YYYY-MM-DD';
  if (readonly || $state.showReadonlyValue) {
    realFormat = _dateConstants.ORIGIN_TRANSFORM_FORMAT[format || dateType] || 'YYYY-MM-DD';
  }
  if ((0, _lodash.isObject)(value) && !(0, _lodash.isNil)(value)) {
    var startDate = value.startDate,
        endDate = value.endDate;

    return !startDate && !endDate ? null : (startDate ? (0, _moment2.default)(startDate).format(realFormat) : '-') + ' ~ ' + (endDate ? (0, _moment2.default)(endDate).format(realFormat) : '-');
  }
  return value;
}

exports.default = {
  formatIn: formatIn,
  formatOut: formatOut,
  defaultValueFormatter: defaultValueFormatter
};
module.exports = exports['default'];